module.exports = __webpack_public_path__ + "static/media/hiroshi_matsumiya_600x600.07fda9de.jpg";